import { FormActions } from "../../components/common/FormActions";
import { API_CHARTS_OF_ACCOUNTS } from "../../utils/apis";
import {
  createDeleteAction,
  createViewEdit,
  formatDate,
  getForm,
  stringifyName,
} from "../../utils/helpers";
import { URL_CHARTS_CONFIGURABLES } from "../../utils/urls";

export const useChartsOfAccountConfigurables = () => {
  const tableColumns = () => [
    { id: "account_name", header: "Account Name", filter: true },
    { id: "account_code", header: "Account Code", filter: true },
    { id: "account_type", header: "Account Type", filter: true },
    { id: "category", header: "Category" },
    { id: "level", header: "Level" },
    {
      id: "actions",
      header: "Actions",
      filter: false,
    },
  ];

  const tableData = (data: any) => [
    ...data?.map((item: any) => {
      const row = {
        ...item,
        account_code: item?.general_ledger_code,
        created_at: formatDate(item.created_at),
        actions: (
          <FormActions
            actions={[
              ...createViewEdit(URL_CHARTS_CONFIGURABLES, item?.id),
              createDeleteAction(
                `${API_CHARTS_OF_ACCOUNTS}${item?.id}/`,
                `Chart of Account ${item?.account_name}`,
              ),
            ]}
          />
        ),
      };
      return row;
    }),
  ];

  const viewData = (item: any) => {
    return {
      account_name: item?.account_name,
      account_code: item?.general_ledger_code,
      account_type: item?.account_type,
      category: item?.category,
      level: item?.level,
      description: item?.description,
      created_by: stringifyName({ ...item?.created_by }),
      created_at: formatDate(item?.created_at),
    };
  };

  const formRoute = getForm(URL_CHARTS_CONFIGURABLES);
  return { tableColumns, tableData, formRoute, viewData };
};
